<ng-katex-paragraph  class="question text-quest" [paragraph]="question.text | exerciseFormat:'text'"></ng-katex-paragraph>
<table class="task">
  <tr>
    <td class="number">{{ qIndex + 1 }}.</td>
    <td class="task_text">
      <div class="input-group big active">
        <span class="cross" *ngIf="isAuthorCard && isAccessCard" (click)="clearAnswer($event)">x</span>
        <input
          type="text"
          name=""
          class="text-left"
          [(ngModel)]="answerStr"
          [disabled]="!isAuthorCard || !isAccessCard"
          (ngModelChange)="answerInputChange($event)"
          [class.true]="checkQuestionAnswer()"
          [class.false]="!checkQuestionAnswer()"
          [class.empty]="isEmptyAnswer()"
        >
      </div>
    </td>
  </tr>
  <!-- # Task content -->
</table>

